import React from 'react';
import ProductCard from './ProductCard';

const products = [
  {
    id: 1,
    name: "SR-01 // CONCRETE",
    price: 240,
    badge: "Edition of 300",
    description: "Constructed with reinforced ballistic mesh and distressed suede. Built for the urban grid.",
    image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?q=80&w=1000&auto=format&fit=crop"
  },
  {
    id: 2,
    name: "SR-01 // ACID TOXIN",
    price: 260,
    badge: "Edition of 200",
    description: "High-visibility upper with reflective threading. Stand out when the lights go down.",
    image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?q=80&w=1000&auto=format&fit=crop"
  }
];

const DropSection = () => {
  return (
    <section id="drop" className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="mb-12 flex items-end justify-between border-b border-[#333] pb-6">
        <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter">The Drop</h2>
        <span className="text-acid font-mono text-xl hidden sm:block">02 ITEMS</span>
      </div>
      
      <div className="flex flex-col gap-12">
        {products.map((product, idx) => (
          <ProductCard key={product.id} product={product} index={idx} />
        ))}
      </div>
    </section>
  );
};

export default DropSection;